import { render } from "./BillingPortal.vue?vue&type=template&id=5aaa4d99&scoped=true"
import script from "./BillingPortal.vue?vue&type=script&lang=js"
export * from "./BillingPortal.vue?vue&type=script&lang=js"

import "./BillingPortal.vue?vue&type=style&index=0&id=5aaa4d99&scoped=true&lang=css"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaa4d99"]])

export default __exports__